import { useMemo } from "react";
import { cx } from "../../utils";
import { BadgeSize } from "../Badge";

export const BadgeSkeleton = ({
  className,
  size
}: {
  className?: string;
  size?: BadgeSize;
}) => {
  const height = useMemo(() => {
    switch (size) {
      case BadgeSize.SM:
        return "h-[20px]";
      case BadgeSize.LG:
        return "h-[32px]";
      case BadgeSize.BASE:
      default:
        return "h-[24px]";
    }
  }, [size]);

  return (
    <div
      className={cx(
        "animate-pulse rounded-lg bg-alpha-100",
        height,
        className || "w-[60px]"
      )}
    />
  );
};
